/** Central query-key registry so invalidation never guesses a key shape. */

import type { LedgerAccount, LedgerKind } from '@shared/ledger';

/** The two ledger filters, with `null` standing for "no filter". */
export interface LedgerFilters {
  account: LedgerAccount | null;
  kind: LedgerKind | null;
  limit: number;
}

export const queryKeys = {
  profile: ['profile'] as const,
  balance: ['balance'] as const,
  stats: ['stats'] as const,
  kyc: ['kyc'] as const,
  cards: ['cards'] as const,
  sessions: ['sessions'] as const,
  notificationPrefs: ['notification-prefs'] as const,

  transactions: {
    all: ['transactions'] as const,
    list: (limit: number) => ['transactions', 'list', limit] as const,
    detail: (id: string) => ['transactions', 'detail', id] as const,
  },

  /**
   * The money layer is grouped under one prefix so a settlement can invalidate
   * every figure that depends on the ledger with a single call.
   */
  money: {
    all: ['money'] as const,
    balances: ['money', 'balances'] as const,
    traffic: ['money', 'traffic'] as const,
    commission: ['money', 'commission'] as const,
    ledger: {
      all: ['money', 'ledger'] as const,
      list: (filters: LedgerFilters) =>
        ['money', 'ledger', filters.account, filters.kind, filters.limit] as const,
    },
    withdrawals: {
      all: ['money', 'withdrawals'] as const,
      list: (limit: number) => ['money', 'withdrawals', limit] as const,
    },
  },
} as const;
